var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid pt-0 row mx-0 bg-primary"},[_c('truckage-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }